module.exports = __webpack_public_path__ + "images/icons_v2/charge-filled-97908534.svg";